import * as z from "zod";
import { mutator } from "./mutator";

export const refreshDuplicateDetectionSchema = z.object({});

// The optimistic in-progress write (fresh startedAt, null completedAt) doubles
// as a claim: the hourly detection tick only re-runs a tenant whose last run
// finished long ago or stalled, so a just-started run is left alone.
export const refreshDuplicateDetection = mutator({
  schema: refreshDuplicateDetectionSchema,
  resolve: {},
  permissions: {
    none: "The duplicate-workflows card is open to any tenant member; detection is idempotent and cost-bounded (re-judges only content-changed pairs, capped per run) and writes only tenant-level scheduling state.",
  },
  fn: async ({ tx, ctx }) => {
    await tx.mutate.duplicateDetectionRuns.upsert({
      tenantId: ctx.tenantId,
      startedAt: Date.now(),
      completedAt: null,
    });
  },
});
